module.exports = __webpack_public_path__ + "media/images/flags/kn-039620e17df2265b44e284d439678428.svg";